import React, { Component } from 'react';
import PropTypes from "prop-types";

export default class PublicSpaceCardDetailsGoogleMapView extends Component {

    static propTypes = {
        longitude: PropTypes.number.isRequired,
        latitude: PropTypes.number.isRequired,
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        this._renderMap();
    }

    componentDidMount() {
        this._renderMap()
    }

    render() {
        return (
            <div id="space_card_view_map" className="space_card_view_map"/>
        );
    }

    _renderMap() {
        const google = window.google;
        const center = {lat: this.props.latitude, lng: this.props.longitude};

        const map =
            new google.maps.Map(
                document.getElementById("space_card_view_map"),
                {
                    zoom: 17,
                    center: center,
                    streetViewControl: false,
                    mapTypeControl: false,
                    disableDoubleClickZoom: true,
                    fullscreenControl: false,
                    clickableIcons: false,
                    draggable:false,
                    disableDefaultUI: true,
                });
        new google.maps.Marker(
            {
                position: center,
                map: map,
                icon: "../../CuveredPinSmall.png"
            });
    }
}

